<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-table-merge-cells"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          SIG-R Compara
        </div>
      </template>
      <v-btn
        id="btn-novo-comparativo"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float:left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon
          left
          size="30px"
        >
          mdi-plus-circle
        </v-icon>
        Novo Comparativo
      </v-btn>
      <v-text-field
        id="comparativo-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-sig-r ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <general-progress-bars
        class="mt-11"
        :items="downloadProgressData"
        prefix-text="Baixando Comparativo"
      />
      <v-divider class="mt-10" />
      <v-data-table
        class="sig-r-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhum comparativo disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.titulo`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                class="text-truncate-column"
                :class="['EXECUTANDO','AGUARDANDO'].includes(item.status) ? 'clickable-item' : ''"
                v-on="on"
                @click="openModalAcompanhamento(item)"
              >
                {{ item.titulo }}
              </div>
            </template>
            <span>{{ item.titulo }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.data_processamento`]="{ item }">
          {{ item.data_processamento }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-comparativo"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            color="gray"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="(downloadProgressData[item.id] !== undefined) ? true : false"
            @click="downloadItem(item, item.titulo)"
          >
            <v-icon small>
              mdi-download
            </v-icon>
          </v-btn>
          <v-btn
            id="action-edit-comparativo"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            color="gray"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-comparativo"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>
                  mdi mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item 
                v-if="canRunItem(item)"
                @click="executarComparativo(item.id)"
              >
                <v-list-item-title>
                  <v-icon small>
                    mdi-play
                  </v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item 
                v-if="item.status == 'SUCESSO'"
                @click="duplicarComparativo(item.id)"
              >
                <v-list-item-title>
                  <v-icon
                    small
                  >
                    mdi-content-copy
                  </v-icon>
                  Duplicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="canDeleteItem(item)"
                @click="openDialogDelete(item.id, item.titulo)"
              >
                <v-list-item-title>
                  <v-icon small>
                    mdi-trash-can-outline
                  </v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="openDialogDetalhes(item)"
              >
                <v-list-item-title>
                  <v-icon small>
                    mdi-file-find-outline
                  </v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete 
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deleteComparativoSigR(dialogDeleteData.id)"
    >
      <template slot="title">
        Deletar Comparativo #{{ dialogDeleteData.id }}
      </template>
      <template slot="body">
        Tem certeza que deseja deletar o comparativo <strong>{{ dialogDeleteData.titulo }}</strong>?
      </template>
    </dialog-delete>
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        >
          <template v-slot:item="row">
            <tr>
              <td
                class="button"
                width="210px"
              >
                {{ row.item.parametro }}
              </td>
              <td
                v-if="row.item.parametro != 'ODIS:' || !row.item.valor"
                class="button"
              >
                {{ row.item.valor }}
              </td>
              <td
                v-else-if="row.item.valor.length == 0"
                class="button"
              />
              <td
                v-else-if="row.item.valor.length == 1"
                class="button"
              >
                {{ row.item.valor[0] }}
              </td>
              <td
                v-else
                class="button"
                style="padding-left:0px !important;"
              >
                <v-textarea
                  rows="4"
                  no-resize
                  readonly
                  class="ml-4 mt-0 pt-0"
                  :value="$refs.dialogDetalhes.updateValueTextArea(row.item.valor)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
    <general-dialog-acompanhamento
      ref="dialogAcompanhamento"
      :show-dialog="dialogAcompanhamento"
      :messages="dialogAcompanhamentoData.andamento"
      :name-event-pusher="'andamento-comparativo-bdgd-ais-'+dialogAcompanhamentoData.id"
      @changeValue="dialogAcompanhamento = $event"
    >
      <template slot="title">
        Andamento do Comparativo #{{ dialogAcompanhamentoData.id }}
      </template>
    </general-dialog-acompanhamento>
  </v-container>
</template>

<script>
import SigRComparaService from '@/services/SigRComparaService';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

export default {
  name: 'SigRDataTables',

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete'),
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
    GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes'),
    GeneralDialogAcompanhamento: () => import('@/components/general/GeneralDialogAcompanhamento')
  },

  mixins: [powerupsActionsMixins],

  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading:{
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      powerupService: SigRComparaService,
      powerupEntityName: 'SIG-R_Compara',
      dialogDelete: false,
      dialogDeleteData: {id: undefined, nome: undefined},
      dialogDetalhes: false,
      dialogDetalhesData: [],
      dialogDetalhesHeader: [
        {text: 'Parâmetro', value: 'parametro', sortable: false},
        {text: 'Valor', value: 'valor', sortable: false}
      ],
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'titulo'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      comparativos: [],
      downloadProgressData: {},
      dialogAcompanhamento: false,
      dialogAcompanhamentoData: {id: undefined, andamento: []}
    };
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },

  methods: {
    openDialogDelete(id, titulo) {
      this.dialogDeleteData = {id: id, titulo: titulo};
      this.dialogDelete = true;
    },

    openDialogDetalhes(comparativo) {
      this.dialogDetalhesData = [
        {
          parametro: 'TIPO:',
          valor: comparativo.tipo
        },
        {
          parametro: 'ORIGEM AIS:',
          valor: comparativo.origem_ais == 'ARQUIVO' ? 'Arquivo' : 'Banco'
        },
        {
          parametro: 'DATA BDGD:',
          valor: comparativo.data_bdgd
        },
        {
          parametro: 'DATA AIS:',
          valor: comparativo.data_ais
        },
        {
          parametro: 'DATA IMOB INÍCIO:',
          valor: comparativo.data_imobilizacao_inicio
        },
        {
          parametro: 'DATA IMOB FIM:',
          valor: comparativo.data_imobilizacao_fim
        },
        {
          parametro: 'COMPARAR POR TI:',
          valor: comparativo.compara_ti
        },
        {
          parametro: 'COMPARAR POR ANO:',
          valor: comparativo.compara_ano
        },
        {
          parametro: 'SOBRA FÍSICA BDGD:',
          valor: comparativo.sobra_fisica
        },
        {
          parametro: 'TUCS:',
          valor: comparativo.tucs
        },
        {
          parametro: 'ODIS:',
          valor: comparativo.odis
        }
      ];

      this.dialogDetalhes = true;
    },

    deleteComparativoSigR(id) {
      SigRComparaService.deleteComparativo(id)
        .then(() => {
          this.$toast.success('Comparativo excluido com sucesso.', '', {position:'topRight'});
          this.$emit('recharge');
        })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao excluir comparativo SIG-R.', '', {position:'topRight'});
        });

      this.dialogDelete = false;
    },

    executarComparativo(id) {
      SigRComparaService.executarComparativo(id)
        .then(() => {
          this.$emit('recharge');
          this.$toast.success('Sua planilha será gerada em instantes. Por favor, aguarde.', '', {position:'topRight'});
        })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao executar comparativo.', '', {position:'topRight'});
        });
    },

    duplicarComparativo(id) {
      SigRComparaService.duplicarComparativo(id)
        .then(() => {
          this.$toast.success('Comparativo duplicado com sucesso.', '', {position:'topRight'});
          this.$emit('recharge');
        })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao duplicar comparativo.', '', {position:'topRight'});
        });
    },

    baixarComparativo(comparativo) {
      const id = comparativo.id;
      const nomeComparativo = `SIG_R_${comparativo.titulo}.xlsx`;

      this.$set(this.downloadProgressData, id, {id}); 
      this.$toast.info('Preparando seu arquivo para download.', '', {position:'topRight', timeout: 2000});

      SigRComparaService.download(comparativo.id, {
        timeout: 60 * 60 * 1000,
        onDownloadProgress: (progressEvent) => {
          let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          let isComputable = progressEvent.lengthComputable;
          this.$set(this.downloadProgressData, id, {progress, isComputable, id});
        }
      })
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', nomeComparativo);
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.$toast.error('Erro ao gerar arquivo xlsx com o resultado do Comparativo.', '', {position: 'topRight'});
          typeof error.response !== 'undefined' ? console.error(error.response.data.erro) : console.error('Erro: ', error);
        })
        .finally(() => {
          this.$delete(this.downloadProgressData, id);
        });
    },

    openModalAcompanhamento(comparativo) {
      if (!['EXECUTANDO', 'AGUARDANDO'].includes(comparativo.status)) { return; }
      this.dialogAcompanhamentoData.id = comparativo.id;
      this.dialogAcompanhamento = true;

      this.attAndamento(comparativo.id);
    },

    attAndamento(id) {
      SigRComparaService.andamento(id)
        .then((response) => {
          this.dialogAcompanhamentoData.andamento = response.data.andamento;
          this.$refs.dialogAcompanhamento.activatePusher();
        })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar andamento do comparativo.', '', {position:'topRight'});
        });
    }
  }
};
</script>

<style>
@media screen and (min-width: 800px) {
  .sig-r-table table tr td:nth-child(2) {
    max-width: 200px;
  }

  .sig-r-table table tr td:nth-child(5),
  .sig-r-table table tr td:nth-child(6) {
    white-space: nowrap !important;
  }
}

@media screen and (max-width: 480px) {
  .bs-sig-r {
    width: 215.36px !important;
  }
}

.swithInterna label {
  font-size: 13px !important;
  margin-left: 0px !important;
}
</style>